import { useState } from "react";
import { KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api from "@/lib/api";

export const WachtwoordWijzigenDialog = ({ open, onOpenChange }) => {
  const [huidig, setHuidig] = useState("");
  const [nieuw, setNieuw] = useState("");
  const [herhaal, setHerhaal] = useState("");
  const [bezig, setBezig] = useState(false);

  const reset = () => { setHuidig(""); setNieuw(""); setHerhaal(""); };

  const opslaan = async (e) => {
    e.preventDefault();
    if (nieuw !== herhaal) { toast.error("De twee nieuwe wachtwoorden zijn niet gelijk."); return; }
    if (nieuw.length < 8) { toast.error("Het nieuwe wachtwoord moet minimaal 8 tekens bevatten."); return; }
    setBezig(true);
    try {
      await api.post("/auth/change-password", {
        huidig_wachtwoord: huidig, nieuw_wachtwoord: nieuw, nieuw_wachtwoord_herhaal: herhaal,
      });
      toast.success("Je wachtwoord is gewijzigd.");
      reset();
      onOpenChange(false);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Wachtwoord wijzigen is niet gelukt.");
    } finally {
      setBezig(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) reset(); onOpenChange(v); }}>
      <DialogContent className="sm:max-w-md" data-testid="wachtwoord-wijzigen-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading text-[#3A281B]">
            <KeyRound className="w-4 h-4 text-[#B9772B]" /> Wachtwoord wijzigen
          </DialogTitle>
          <DialogDescription>
            Vul je huidige wachtwoord in en kies een nieuw wachtwoord (minimaal 8 tekens).
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={opslaan} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="ww-huidig">Huidig wachtwoord</Label>
            <Input id="ww-huidig" type="password" required autoComplete="current-password"
              data-testid="wachtwoord-huidig-input" value={huidig} onChange={(e) => setHuidig(e.target.value)} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="ww-nieuw">Nieuw wachtwoord</Label>
            <Input id="ww-nieuw" type="password" required minLength={8} autoComplete="new-password"
              data-testid="wachtwoord-nieuw-input" value={nieuw} onChange={(e) => setNieuw(e.target.value)} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="ww-herhaal">Herhaal nieuw wachtwoord</Label>
            <Input id="ww-herhaal" type="password" required minLength={8} autoComplete="new-password"
              data-testid="wachtwoord-herhaal-input" value={herhaal} onChange={(e) => setHerhaal(e.target.value)} />
          </div>
          <Button type="submit" disabled={bezig} data-testid="wachtwoord-wijzigen-opslaan"
            className="w-full zk-brand-gradient text-white">
            {bezig ? "Bezig met opslaan…" : "Wachtwoord wijzigen"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
